export enum GlobalSiteDomainEnum {
  StandardPay = 'STANDARD_PAY',
  WastePay = 'WASTE_PAY'
}
